import React, { Component } from "react";
import Autosuggest          from 'react-autosuggest';
import YouTubeThumbnail     from "../../components/YouTubeThumbnail";
import { invokeGetProgramDayViewSearchExercises } from "../../utils/AwsInvoke";
import "../../css/autosuggest/AutoSuggest.css";

var AutosuggestHighlightMatch = require('autosuggest-highlight/match');
var AutosuggestHighlightParse = require('autosuggest-highlight/parse');

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestionValue(suggestion) {
    return suggestion.name;
}

function handleDetailView (event) {
      event.stopPropagation()
      //event.preventDefault();
      //console.log("SELECT");
}

function getImageDirectoryByFullURL(url){
    if(url != null)
        return url.split('/').pop()
}

function renderSuggestion(suggestion, { query }) {
  const matches = AutosuggestHighlightMatch(suggestion.name, query);
  const parts = AutosuggestHighlightParse(suggestion.name, matches);

  var yt_id = getImageDirectoryByFullURL(suggestion.youtube); // get id of yt video

  return (
    <span>

      <span onClick = {(e) => handleDetailView(e)}> { /*}//{(e) => this.handleDetailView.bind(e)}> */ }
          <YouTubeThumbnail yt_id={yt_id} width={60}/> &nbsp;
      </span>

      { parts.map((part, index) => {
        const className = part.highlight ? 'react-autosuggest__suggestion-match' : null;

        return (
          <span className={className} key={index} >
            {part.text}
          </span>
        );
      })}
      <span className="autoSuggestDropdown"></span>
    </span>
  );
}

function getSuggestions(results, value) {
    const escapedValue = escapeRegexCharacters(value.trim());
    if (escapedValue === '') { return []; }

    const regex = new RegExp('^' + escapedValue, 'i');
    //return exercises.filter(exercise => regex.test(exercise.name));
    return results;
}

export default class AutoSuggest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            uid: '',
            suggestions: []
        };
   }

   async onSuggestionsFetchRequested ({ value, uid }) {
      var exer_arr = [];
      try {

          if(value.length > 2) {
              const results = await invokeGetProgramDayViewSearchExercises(value);

              for(var key in results) {
                  exer_arr.push({name: results[key].name, uid: results[key].uid, youtube: results[key].youtube_id})
              }

              this.setState({
                  suggestions: getSuggestions(exer_arr, value)
              });
          }
      } catch (e) {
        alert(e);
      }
   };

   componentWillMount = () => {
       this.setState({
           value: this.props.exercise_name,
           uid:   this.props.exercise_id
       })
   }

   componentWillReceiveProps (nextProps) {
       var exercise_id      = nextProps.exercise_id;
       var exercise_name    = nextProps.exercise_name;

       this.setState({
           value:    exercise_name,
           uid:      exercise_id
       })
   }

   onChange = (event, { newValue, method }) => {
       this.setState({
         value: newValue
       });
   };

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
      var yt_id = getImageDirectoryByFullURL(suggestion.youtube); // get id of yt video
      this.props.handleExerciseChange(suggestion.uid, suggestion.name, yt_id)
  }

  clearTextfield () {
      var clear_textfield = this.props.clearTextfield;

      this.setState({
          value: ""
      })
  }

  onSuggestionsClearRequested = () => {
       this.setState({
           suggestions: []
       });
  };

  render() {
      const { value, suggestions } = this.state;
      const inputProps = {
         placeholder: "Enter an exercise name",
         value: value,
         onChange: this.onChange
     };

     return (
         <span>
             <Autosuggest
               suggestions={suggestions}
               onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
               onSuggestionsClearRequested={this.onSuggestionsClearRequested}
               onSuggestionSelected={this.onSuggestionSelected}
               getSuggestionValue={getSuggestionValue}
               renderSuggestion={renderSuggestion}
               //onSuggestionsUpdateRequested={this.onSuggestionsUpdateRequested}
               inputProps={inputProps}
             />
             <span className="clearTextfieldModalBox">
                 <span className="glyphicon glyphicon-remove-circle clearTextfieldModal"
                       onClick={() => this.clearTextfield()}
                 />
             </span>
         </span>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/autosuggest/AutoSuggest.js